import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme/myPalette'

export const Description = styled.div`
  font-size: 14px;
  color: ${myPalette.mutedText.main};
  margin-bottom: 2px;
`
